export var TemplateLinkType;
(function(TemplateLinkType2) {
  TemplateLinkType2["MASTER_PRODUCT_SENIOR"] = "MASTER_PRODUCT_SENIOR";
  TemplateLinkType2["MASTER_PRODUCT_NORMAL"] = "MASTER_PRODUCT_NORMAL";
  TemplateLinkType2["AUTO_UPDATE_BIND_RULE"] = "AUTO_UPDATE_BIND_RULE";
  TemplateLinkType2["UPDATE_PRICE"] = "UPDATE_PRICE";
  TemplateLinkType2["EDIT_PRODUCT"] = "EDIT_PRODUCT";
  TemplateLinkType2["BIND_PRODUCT"] = "BIND_PRODUCT";
  TemplateLinkType2["UPDATE_SAFE_STOCK"] = "UPDATE_SAFE_STOCK";
  TemplateLinkType2["PROMOTION_IMPORT_SHOPEE"] = "PROMOTION_IMPORT_SHOPEE";
  TemplateLinkType2["PROMOTION_IMPORT_BUKALAPAK"] = "PROMOTION_IMPORT_BUKALAPAK";
  TemplateLinkType2["PROMOTION_IMPORT_TOKOPEDIA"] = "PROMOTION_IMPORT_TOKOPEDIA";
  TemplateLinkType2["EXPORT_CUSTOMER"] = "EXPORT_CUSTOMER";
  TemplateLinkType2["PURCHASE_SUPPLIER_CREATE_IMPORT"] = "PURCHASE_SUPPLIER_CREATE_IMPORT";
  TemplateLinkType2["PURCHASE_SUPPLIER_UPDATE_IMPORT"] = "PURCHASE_SUPPLIER_UPDATE_IMPORT";
  TemplateLinkType2["PURCHASE_ORDER_IMPORT"] = "PURCHASE_ORDER_IMPORT";
})(TemplateLinkType || (TemplateLinkType = {}));
export var LanguageType;
(function(LanguageType2) {
  LanguageType2["en"] = "en";
  LanguageType2["zh"] = "zh";
  LanguageType2["vn"] = "vn";
  LanguageType2["th"] = "th";
  LanguageType2["id"] = "id";
})(LanguageType || (LanguageType = {}));
const linkMap = {
  MASTER_PRODUCT_SENIOR: {
    zh: "https://cdn-erp.ginee.com/erp/template/product/20220829/Import_to_Create_Template_PRo_CN.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/product/20220829/Import_to_Create_Template_PRo_EN.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/product/20220829/Import_to_Create_Template_PRo_ID.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/product/20220829/Import_to_Create_Template_PRo_TH.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/product/20220829/Import_to_Create_Template_PRo_VN.xlsx"
  },
  MASTER_PRODUCT_NORMAL: {
    zh: "https://cdn-erp.ginee.com/erp/template/product/20220829/Import_and_create_products_basic_CN.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/product/20220829/Import_and_create_products_basic_EN.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/product/20220829/Import_and_create_products_basic_ID.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/product/20220829/Import_and_create_products_basic_TH.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/product/20220829/Import_and_create_products_basic_VN.xlsx"
  },
  AUTO_UPDATE_BIND_RULE: {
    zh: "https://cdn-erp.ginee.com/erp/template/product/20210510/automatic-binding-rule-template-zh.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/product/20210510/automatic-binding-rule-template-en.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/product/20210510/automatic-binding-rule-template-id.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/product/20210806/automatic_binding_rule_template_TH.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/product/20210806/automatic_binding_rule_template_VN.xlsx"
  },
  UPDATE_PRICE: {
    zh: "https://cdn-erp.ginee.com/erp/template/product/20230131/Import_and_update_prices_CN.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/product/20230131/Import_and_update_prices_EN.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/product/20230131/Import_and_update_prices_ID.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/product/20230131/Import_and_update_prices_TH.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/product/20230131/Import_and_update_prices_VN.xlsx"
  },
  EDIT_PRODUCT: {
    zh: "https://cdn-erp.ginee.com/erp/template/product/20210825/%E5%AF%BC%E5%85%A5%E7%BC%96%E8%BE%91%E5%95%86%E5%93%81%E6%A8%A1%E7%89%88-CN.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/product/20210825/Import%20to%20edit%20product%20template-EN.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/product/20210825/Import_to_edit_product_template_ID.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/product/20210825/Import%20to%20edit%20product%20template-TH.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/product/20210825/Import%20to%20edit%20product%20template-VN.xlsx"
  },
  BIND_PRODUCT: {
    zh: "https://cdn-erp.ginee.com/erp/template/product/20210825/import-to-bind-product-zh.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/product/20210825/import-to-bind-product-en.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/product/20210825/import-to-bind-product-id.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/product/20210825/import_to_bind_product_TH.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/product/20210825/import_to_bind_product_vn.xlsx"
  },
  UPDATE_SAFE_STOCK: {
    zh: "https://cdn-erp.ginee.com/erp/template/product/20210304/update%20safety%20stock%20template-CN.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/product/20210304/update%20safety%20stock%20template-EN.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/product/20210304/update%20safety%20stock%20template-Bahasa.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/product/20210806/update%20safety%20stock%20template--TH.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/product/20210806/update%20safety%20stock%20template--VN.xlsx"
  },
  EXPORT_CUSTOMER: {
    zh: "https://cdn-erp.ginee.com/erp/template/customer/customer-list-ZH_V3.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/customer/customer-list-EN_V3.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/customer/customer-list-VN_V3.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/customer/customer-list-TH_V3.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/customer/customer-list-ID_V3.xlsx"
  },
  PROMOTION_IMPORT_BUKALAPAK: {
    zh: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Bukalapak_%E6%8A%98%E6%89%A3%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF_ZH_v1.xlsx",
    en: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Bukalapak_Promotion-Import-Template_EN_v1.xlsx",
    id: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Bukalapak_Promosi-Impor-Template_ID_v1.xlsx",
    th: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Bukalapak_%E0%B9%80%E0%B8%97%E0%B8%A1%E0%B9%80%E0%B8%9E%E0%B8%A5%E0%B8%95%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%99%E0%B8%B3%E0%B9%80%E0%B8%82%E0%B9%89%E0%B8%B2%E0%B8%AA%E0%B9%88%E0%B8%A7%E0%B8%99%E0%B8%A5%E0%B8%94_TH_v1.xlsx",
    vn: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Bukalapak_Ma%CC%82%CC%83u-nha%CC%A3%CC%82p-chie%CC%82%CC%81t-kha%CC%82%CC%81u_VN_v1.xlsx"
  },
  PROMOTION_IMPORT_TOKOPEDIA: {
    zh: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Tokopedia_%E6%8A%98%E6%89%A3%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF_ZH_v1.xlsx",
    en: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Tokopedia_Promotion-Impor-Template_EN_v1.xlsx",
    id: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Tokopedia_Promosi-Impor-Template_ID_v1.xlsx",
    th: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Tokopedia_%E0%B9%80%E0%B8%97%E0%B8%A1%E0%B9%80%E0%B8%9E%E0%B8%A5%E0%B8%95%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%99%E0%B8%B3%E0%B9%80%E0%B8%82%E0%B9%89%E0%B8%B2%E0%B8%AA%E0%B9%88%E0%B8%A7%E0%B8%99%E0%B8%A5%E0%B8%94_TH_v1.xlsx",
    vn: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Tokopedia_Ma%CC%82%CC%83u-nha%CC%A3%CC%82p-chie%CC%82%CC%81t-kha%CC%82%CC%81u_VN_v1.xlsx"
  },
  PROMOTION_IMPORT_SHOPEE: {
    zh: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Shopee_%E6%8A%98%E6%89%A3%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF_CN_v1.xlsx",
    en: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Shopee_Promotion-Import-Template_EN_v1.xlsx",
    id: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Shopee_Promosi-Impor-Template_ID_v1.xlsx",
    th: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Shopee_%E0%B9%80%E0%B8%97%E0%B8%A1%E0%B9%80%E0%B8%9E%E0%B8%A5%E0%B8%95%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%99%E0%B8%B3%E0%B9%80%E0%B8%82%E0%B9%89%E0%B8%B2%E0%B8%AA%E0%B9%88%E0%B8%A7%E0%B8%99%E0%B8%A5%E0%B8%94_TH_v1.xlsx",
    vn: "https://genie-public.oss-ap-southeast-1.aliyuncs.com/erp/template/promotion/Shopee_Ma%CC%82%CC%83u-nha%CC%A3%CC%82p-chie%CC%82%CC%81t-kha%CC%82%CC%81u_VN_v1.xlsx"
  },
  PURCHASE_SUPPLIER_CREATE_IMPORT: {
    zh: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Create-Supplier-ZH.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Create-Supplier-EN.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Create-Supplier-ID.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Create-Supplier-TH.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Create-Supplier-VN.xlsx"
  },
  PURCHASE_SUPPLIER_UPDATE_IMPORT: {
    zh: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Update-Supplier-ZH.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Update-Supplier-EN.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Update-Supplier-ID.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Update-Supplier-TH.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Update-Supplier-VN.xlsx"
  },
  PURCHASE_ORDER_IMPORT: {
    zh: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Purchase-Order-ZH.xlsx",
    en: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Purchase-Order-EN.xlsx",
    id: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Purchase-Order-ID.xlsx",
    th: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Purchase-Order-TH.xlsx",
    vn: "https://cdn-erp.ginee.com/erp/template/purchase/Import-Purchase-Order-VN.xlsx"
  }
};
export const useTemplateLink = (type) => {
  const language = window.localStorage.language || "en";
  return linkMap[type][language];
};
